//@flow
import React, {useState} from "react";
import {Popover, Collapse} from "antd";
import {InfoCircleOutlined} from "@ant-design/icons";
import {MarkerContainer, MarkerIcon} from "./markerStyles";
import {CourierIcon} from "components/_defaultComponents/CourierIcon/CourierIcon";
import {formatPhoneNumber} from "../../../utils/helpers";
import {courierStatuses, deliveryStatuses, courierStatusColors} from "../../../constants/constants";
import moment from "moment";

export const CourierMarker = ({lat, lng, courier}) => {
    const [visible, setVisible] = useState(false);
    const getStatusColor = status => {
        return courierStatusColors[status] || "#d9d9d9";
    };

    // Helper to get Turkish status name
    const getStatusName = status => {
        const found = courierStatuses.find(s => s.value === status);
        return found ? found.name : status;
    };
    // Helper to get Turkish delivery state name
    const getDeliveryStateName = state => {
        if (!state) return "Cevap Bekleniyor";
        const found = deliveryStatuses.find(s => s.value === state);
        return found ? found.name : state;
    };

    const handleVisibleChange = vis => {
        setVisible(vis);
    };

    const poolShift = courier.poolShift;
    const delivery = courier.delivery;

    const content = (
        <div style={{minWidth: 320}}>
            <Collapse bordered={false} defaultActiveKey={["1"]}>
                <Collapse.Panel
                    header={
                        <span>
                            <span style={{fontWeight: 600, fontSize: 18}}>
                                {courier.courierName}
                            </span>
                            <InfoCircleOutlined style={{marginLeft: 8}} />
                        </span>
                    }
                    key="1"
                >
                    <ul style={{paddingLeft: 20, marginBottom: 0}}>
                        <li>{formatPhoneNumber(courier.cellPhone)}</li>
                        <li>{getDeliveryStateName(delivery?.deliveryState)}</li>
                        {poolShift?.name && (
                            <li>
                                Havuz Adı:{" "}
                                {poolShift?.poolId ? (
                                    <a
                                        href={`/pools/${poolShift.poolId}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {poolShift.name}
                                    </a>
                                ) : (
                                    poolShift.name
                                )}
                            </li>
                        )}
                        <li>
                            Durum:{" "}
                            <span style={{color: getStatusColor(courier.status)}}>
                                {getStatusName(courier.status)}
                            </span>
                        </li>
                        {poolShift?.shiftStart && (
                            <li>
                                Başlangıç - Bitiş: {moment(poolShift?.shiftStart).format("HH:mm")} -{" "}
                                {moment(poolShift?.shiftEnd).format("HH:mm")}
                            </li>
                        )}
                    </ul>
                </Collapse.Panel>
            </Collapse>
            <Collapse bordered={false} style={{marginTop: 8}}>
                <Collapse.Panel header={<span>Sipariş</span>} key="2">
                    {delivery?.orders && delivery.orders.length > 0 ? (
                        <div>
                            <ul style={{paddingLeft: 20, marginBottom: 0}}>
                                <li>{delivery?.company?.name}</li>
                            </ul>{" "}
                            <ul style={{paddingLeft: 20, marginBottom: 0}}>
                                {delivery.pickupInfos.map(info => (
                                    <li key={info._id}>{info.name}</li>
                                ))}
                            </ul>
                            <ul style={{paddingLeft: 20, marginBottom: 0}}>
                                {delivery.orders.map(order => (
                                    <li key={order._id}>Alıcı Adı: {order.receiverName}</li>
                                ))}
                            </ul>
                        </div>
                    ) : (
                        <div>Bu kurye için sipariş bulunamadı.</div>
                    )}
                </Collapse.Panel>
            </Collapse>
        </div>
    );

    return (
        <MarkerContainer
            color={getStatusColor(courier.status)}
            zIndex={999}
            data-testid="map_courierMarker"
        >
            <Popover
                content={content}
                trigger="click"
                visible={visible}
                onVisibleChange={handleVisibleChange}
            >
                <MarkerIcon
                    icon={<CourierIcon courierType="motorCourier" />}
                    color={getStatusColor(courier.status)}
                />
            </Popover>
        </MarkerContainer>
    );
};
